var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFsn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1D9AD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 6.86931C14.0574 6.27644 12.8914 5.78031 10.7167 5.476C10.0311 5.37999 9.34263 5.30515 8.65236 5.25156C8.1163 5.2195 7.59599 5.18744 7.09199 5.18744C6.25667 6.43619 5.46861 7.942 4.77505 9.75156C4.01849 11.7372 3.34124 13.6913 2.86874 15.4688H2.72699C2.77424 13.5631 3.08924 11.4014 3.73555 9.15925C4.16136 7.70237 4.66536 6.42044 5.23292 5.29994C2.67917 5.57219 0.851049 6.35687 0.000549316 7.47737C0.725612 5.69987 2.88449 4.19462 6.17849 3.66644C7.92786 1.05587 9.99224 -0.113565 11.7101 0.399435C12.3086 0.575498 12.8132 0.959685 13.2232 1.50419C13.1754 1.47212 13.1282 1.44006 13.0657 1.42431C11.8046 0.911873 10.1025 1.64819 8.44761 3.47406H8.52636C12.2299 3.45831 14.1047 5.02769 14.625 6.86931ZM9.99167 9.27119C11.0002 9.27119 11.8198 10.12 11.8198 11.1612C11.8198 12.2018 11.0002 13.0506 9.99167 13.0506C8.98311 13.0506 8.16355 12.2018 8.16355 11.1606C8.16355 10.1042 8.98311 9.27119 9.99167 9.27119Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsn);
export default __webpack_public_path__ + "static/media/fsn.973bc2a34d1efba533334381942aea0c.svg";
export { ForwardRef as ReactComponent };